import ApiClientError from "./ApiClientError";

class UnauthorizedError extends ApiClientError {
  /* istanbul ignore next */
  constructor(request: $TSFixMe, response: $TSFixMe, cause: $TSFixMe) {
    super(
      "UnauthorizedError",
      401,
      "Authentication failed, missing or wrong credentials.",
      request,
      response,
      cause,
    );
  }
}

export default UnauthorizedError;
